import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  editais: (pagina, tituloEdital, numeroEdital, anoEdital) => {
    return Vue.http.get(`/api/editais`, {
      params: {
        pagina,
        tituloEdital,
        numeroEdital,
        anoEdital
      }
    })
      .then(response => response.data);
  },
  informacaoEdital: idEdital => {
    return Vue.http.get(`/api/editais/${idEdital}`)
      .then(response => response.data);
  },
  publicacoes: () => {
    return Vue.http.get(`/api/editais/publicacoes`)
      .then(response => response.data);
  },
  publicacoesEdital: idEdital => {
    return Vue.http.get(`/api/editais/${idEdital}/publicacoes`)
      .then(response => response.data);
  },
  //arquivos: id => {
  //  return Vue.http.get(`/api/transparencia/${id}/arquivos`)
  //    .then(response => response.data);
  //},
  //download: (id, arquivo) => {
  //  return Vue.http.get(`/api/transparencia/${id}/downloadarquivo/${arquivo}`, {
  //    responseType: 'blob'
  //  })
  //    .then(response => {
  //      return salvarArquivo(response, arquivo);
  //    });
  //},
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/edital/servico.js